export default __webpack_public_path__ + "static/media/bg-1.90b9d828.png";